<template>
  <div class="thank-you-box">
    <p class="thank-you-text">
      {{ user.firstName ? user.firstName : policyOwnerName[0].firstName }}
      {{ user.lastName ? user.lastName : policyOwnerName[0].lastName }},
    </p>
    <p>
      Thank you for your interest in Porsche Auto Insurance. Your binder number
      is
      <span class="quote-number-bold">{{
        bindResponse.policies[0].policyNumber
      }}</span
      >.
    </p>
    <p>
      In a moment, you will receive an email containing your policy documents
      and a text message with link to submit your initial odometer photo. Please
      note,
      <strong>
        your policy will not be issued until we receive your signed policy
        documents and an initial, valid odometer photo.
      </strong>
    </p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';
export default {
  name: 'PaymentThankYou',
  props: ['quoteResponse', 'bindResponse'],
  mounted() {
    this.floodlightPurchaseComplete();
  },
  computed: {
    ...mapGetters(['user', 'isLoggedIn']),

    policyOwnerName() {
      const result = this.bindResponse.policies[0].policyOwners.filter(
        primaryDriver => {
          return primaryDriver.relation === 'INSURED';
        }
      );
      return result;
    }
  },
  methods: {
    floodlightPurchaseComplete() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 6 Active');
        // Porsche PAI Receive a Quote Form Thank You Page Load
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `
          <img src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p00;cat=porsc0;qty=1;cost=[Revenue];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=[OrderID]?" width="1" height="1" alt=""/>
        `;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'purchase', {
            allow_custom_scripts: true,
            value: this.quoteResponse.policies[0].estimatedTotalWritten,
            transaction_id: this.bindResponse.policies[0].policyNumber,
            send_to: 'DC-5368208/2025p00/porsc0+transactions'
          });
        }
      }
    },
    continueToHomePage() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.thank-you-box {
  padding-bottom: 10px;
  .thank-you-text {
    font-size: 24px;
  }

  .alert-danger {
    color: red;
  }

  .info-box {
    margin-bottom: 1rem;
  }
  .quote-number-bold {
    font-weight: bold;
  }
}
</style>
